import { render } from "./ExtractingData.vue?vue&type=template&id=22a5db6f&scoped=true"
import script from "./ExtractingData.vue?vue&type=script&lang=js"
export * from "./ExtractingData.vue?vue&type=script&lang=js"

import "../../assets/scss/extracting_data.scss?vue&type=style&index=0&id=22a5db6f&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a5db6f"]])

export default __exports__